import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import React, { useContext } from 'react';
import { EditableInfoContainer } from '@dealstack/frontend/shared/components/EditableInfoContainer/EditableInfoContainer.tsx';
import { EmploymentRecordTile } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/BasicDetails/components/EmploymentRecordSection/components/EmploymentRecordTile.tsx';
import { PersonDataContext } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/BasicDetails/hooks/usePersonData.ts';
import { ConfirmDeleteDrawer } from '@dealstack/frontend/shared/components/ConfirmDeleteDrawer/ConfirmDeleteDrawer.tsx';
import { EmploymentRecordDrawer } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/tabs/BasicDetails/components/EmploymentRecordDrawer/EmploymentRecordDrawer.tsx';
import { CapManageControllerContext } from '@dealstack/frontend/app/pages/Project/Cap/CapEntityManageFlow/CapManageEntityFlow.tsx';

export const EmploymentRecordSection = ({
	hasEditorPermission,
}: {
	hasEditorPermission: boolean;
}) => {
	const tCapManage = useTranslationCapManage();
	const {
		employmentRecords,
		deleteEmploymentRecord,
		setDeleteEmploymentRecord,
		deletePersonEmploymentRecord,
		deletePersonEmploymentRecordLoading,
		deletePersonEmploymentRecordSuccess,
		editEmploymentRecord,
		setEditEmploymentRecord,
		addEmploymentRecord,
		setAddEmploymentRecord,
	} = useContext(PersonDataContext);
	const { personsSelectOptions } = useContext(CapManageControllerContext);

	const deleteEmployerName = deleteEmploymentRecord
		? personsSelectOptions.find((option) => option.value === deleteEmploymentRecord.employerId)
				?.label ?? ''
		: '';

	return (
		<>
			{employmentRecords.length ? (
				<EditableInfoContainer
					title={tCapManage('basic_details.employment_records.title')}
					isEdit={false}
					hasEditorPermission={hasEditorPermission}
					gridColumns={2}
					useGrid={true}
					childrenPadding="0.5rem"
					onAdd={() => setAddEmploymentRecord(true)}
				>
					{employmentRecords.map((record) => (
						<EmploymentRecordTile
							key={record.id}
							employmentRecord={record}
							onRemove={setDeleteEmploymentRecord}
							onEdit={setEditEmploymentRecord}
							hasEditPermission={hasEditorPermission}
						/>
					))}
				</EditableInfoContainer>
			) : null}

			{hasEditorPermission && (
				<>
					<EmploymentRecordDrawer
						opened={addEmploymentRecord}
						onClose={() => setAddEmploymentRecord(false)}
						hasPermission={hasEditorPermission}
						employmentRecord={null}
					/>

					<EmploymentRecordDrawer
						opened={!!editEmploymentRecord}
						onClose={() => setEditEmploymentRecord(null)}
						hasPermission={hasEditorPermission}
						employmentRecord={editEmploymentRecord}
					/>

					<ConfirmDeleteDrawer
						opened={!!deleteEmploymentRecord}
						onClose={() => setDeleteEmploymentRecord(null)}
						title={tCapManage('delete.employment_record.drawer.title')}
						inputLabel={tCapManage('delete.employment_record.drawer.input_label')}
						inputPlaceholder={tCapManage(
							'delete.employment_record.drawer.input_placeholder'
						)}
						confirmDeleteText={
							deleteEmployerName ||
							tCapManage('delete.employment_record.drawer.fallback_name')
						}
						wordMismatchErrorMessage={tCapManage(
							'delete.employment_record.drawer.word_mismatch_error'
						)}
						deleteBtnText={tCapManage('delete.employment_record.drawer.confirm_delete')}
						cancelBtnText={tCapManage('delete.employment_record.drawer.cancel')}
						handleDelete={deletePersonEmploymentRecord}
						deleteLoading={deletePersonEmploymentRecordLoading}
						deleteSuccess={deletePersonEmploymentRecordSuccess}
					/>
				</>
			)}
		</>
	);
};
